import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { LosstrackView } from "./losstrack-view";
export const LosstrackController = (props) => {

	const segments = window.location.pathname.slice(1).split("/");
	const bi_type = segments[1];
	const plant_slug = segments[2];
	const [results, setResults] = useState([]);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	
	useEffect(() => {
		props.handleExpandFal();
				const search = async () => {
				const apiUrl = `/powerbi?param=losstrack&uid=${usid}`;
				const { data } = await serviceProvider.get(apiUrl);
				setResults(data);
			};
			search();
	}, []);
	
	
	
	return <LosstrackView resultsData={results}  {...props} />;
};
